import React from 'react';
import PrivatePageLayout from '../../layout/privatePageLayout/PrivatePageLayout';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import StatePageNotFound from '../pageNotFound/StatePageNotFound';
import './ErrorEncountered.scss';
import { Icon } from '@progress/kendo-react-common';

const StateErrorEncountered = () => {
  const error = useRouteError();

  function renderNotFound() {
    if (isRouteErrorResponse(error)) {
      console.warn(error.statusText);
      if (error.status === 404) {
        return <StatePageNotFound />;
      }

      if (error.status === 401) {
        return <PrivatePageLayout><div className="error-page">You aren't authorized to see this. To request access please contact user@user.com</div></PrivatePageLayout>;
      }

      if (error.status === 503) {
        return <PrivatePageLayout ><div className="error-page">Looks like our API is down. Please contact user@user.com</div></PrivatePageLayout >;
      }

      return (<PrivatePageLayout><div>{error.statusText}</div></PrivatePageLayout>)
    }
    return (
      <PrivatePageLayout>

        <div className="error-page">
          <div className='error-logo'>
            <Icon name='error' size='xlarge' />
          </div>
          <div className='error-message'>
            You've encountered an error. Please contact user@user.com or try reloading the page
          </div>
        </div>
      </PrivatePageLayout>
    )
  }

  return (
    <div>
      {renderNotFound()}
    </div>
  )
};

export default StateErrorEncountered;
